/**
 * Capitalizes the first letter of each word in a string.
 *
 * - Works with one or multiple words
 * - Handles multiple spaces between words
 *
 * @param {string} str - Input string
 * @returns {string} String with each word capitalized
 *
 * @example
 * capitalize("hello");
 * // "Hello"
 *
 * @example
 * capitalize("hello world");
 * // "Hello World"
 */
export const capitalize = str => {
  return str
    .trim()
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
